import { render } from "./completeIcon.vue?vue&type=template&id=6cfe5e56"
import script from "./completeIcon.vue?vue&type=script&lang=js"
export * from "./completeIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__